module.exports = __webpack_public_path__ + "img/logo_text.bf5d730c.svg";